import { defineTextStyles } from "@chakra-ui/react";

export const FONT_WEIGHT = {
  BOLD: 700,
  HEAVY: 600,
  NORMAL: 400,
};

export const FONT_FAMILY = {
  PRIMARY: "Open Sans",
  SECONDARY: "Crimson Text",
};

/**
 * Two v3 behaviours to keep in mind when using these:
 * - a `textStyle` overrides any style prop written *before* it on the same element, so put
 *   `textStyle` first and `color`/`fontWeight`/… after it (v2 always let the props win);
 * - these merge into Chakra's own text styles, and v3 ships a `label` style of its own, so
 *   `label` pins its line height back to the inherited 1.5 instead of v3's 20px.
 */
const textStyles = defineTextStyles({
  label: {
    value: {
      lineHeight: "1.5",
      fontWeight: FONT_WEIGHT.NORMAL,
      fontSize: "12px",
      color: "blue.700",
    },
  },
  title: {
    value: {
      fontSize: "32px",
      fontFamily: FONT_FAMILY.SECONDARY,
      fontWeight: FONT_WEIGHT.BOLD,
      lineHeight: "41px",
      color: "brand.black",
    },
  },
  subtitle: {
    value: {
      fontSize: "26px",
      fontFamily: FONT_FAMILY.SECONDARY,
      fontWeight: FONT_WEIGHT.HEAVY,
      lineHeight: "33.79px",
      color: "brand.black",
      letterSpacing: "1px",
    },
  },
  noMatchesTitle: {
    value: {
      fontSize: "32px",
      fontFamily: FONT_FAMILY.SECONDARY,
      fontWeight: FONT_WEIGHT.BOLD,
      lineHeight: "41px",
      color: "brand.emptyStateText",
    },
  },
  noMatchesSubtitle: {
    value: {
      fontSize: "14px",
      fontFamily: FONT_FAMILY.PRIMARY,
      fontWeight: FONT_WEIGHT.NORMAL,
      lineHeight: "19px",
      color: "brand.emptyStateText",
    },
  },
  modalTitle: {
    value: {
      fontSize: "14px",
      fontFamily: FONT_FAMILY.PRIMARY,
      fontWeight: FONT_WEIGHT.HEAVY,
      lineHeight: "32px",
      color: "brand.modalHeaderText",
    },
  },
  overlayTitle: {
    value: {
      fontSize: "16px",
      fontFamily: FONT_FAMILY.PRIMARY,
      fontWeight: FONT_WEIGHT.HEAVY,
      lineHeight: "normal",
      color: "blue.900",
    },
  },
  listWithIcons: {
    value: {
      fontSize: "16px",
      fontFamily: FONT_FAMILY.PRIMARY,
      fontWeight: FONT_WEIGHT.NORMAL,
      lineHeight: "28px",
    },
  },
});

export type TextStyles = typeof textStyles;

export default textStyles;
